module.exports = __webpack_public_path__ + "img/ksh1.389c7415.png";